export default "__VITE_ASSET__1c388134__"